export default __webpack_public_path__ + "static/media/word.4b152b32.png";